// extracted by mini-css-extract-plugin
export var container = "_j2-1";
export var cornerButtonContainer = "_j2-6";
export var disabled = "_j2-2";
export var dragActive = "_j2-3";
export var fileContainer = "_j2-5";
export var hiddenInput = "_j2-4";
export var widthContainer = "_j2-0";